import{HttpInterceptor, HttpRequest, HttpHandler}from'@angular/common/http'
import {Injectable}from'@angular/core'
import {ScholarAuthService}from'./scholar-auth.service'
@Injectable()
export class ScholarAuthInterceptor implements HttpInterceptor{
    constructor(private scholarAuthService:ScholarAuthService){}
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const token=this.scholarAuthService.getToken();
        const authRequest=req.clone({
            headers:req.headers.set('ScholarAuthorization',"Bearer "+token)
        })
        return next.handle(authRequest)
    }
}